import React from 'react';
import styles from './RingingBell.css';
import { Bell } from './Bell';
import { Clapper } from './Clapper';
const RingingBell = () => (React.createElement("div", { className: styles.iconWrapper },
    React.createElement(Bell, null),
    React.createElement(Clapper, { className: styles.clapper })));
export { RingingBell };
//# sourceMappingURL=RingingBell.js.map